import styled from "styled-components";
import { grid, GridProps } from "styled-system";

type TimelineGridItemProps = GridProps;

export const TimelineGridItem = styled.div<TimelineGridItemProps>`
  grid-row: 1 / span 1;
  ${grid}
`;
